import * as React from 'react'
import { Query, QueryResult } from 'react-apollo'
import { Settings } from 'react-feather'

import { USER_QUERY } from 'main/gql/user'
import { palette } from 'main/ui'
import { IRankingFactorWeights } from 'main/util/search'
import { SettingsIconContainer } from './RankingWeights.styles'
import RankingWeightsModal from './RankingWeightsModal'

interface IProps {
  rankingWeights: IRankingFactorWeights | null
  onChangeRankingWeights: (rankingWeights: IRankingFactorWeights) => void
}

export default function RankingWeights(props: IProps) {
  const { rankingWeights, onChangeRankingWeights } = props
  const [displayRankingWeightsModal, setDisplayRankingWeightsModal] = React.useState<boolean>(false)

  return (
    <Query query={USER_QUERY}>
      {(result: QueryResult) => {
        const { data, loading, error } = result
        if (loading || error || !data || !data.user || !data.user.admin) return null

        return (
          <>
            <SettingsIconContainer onClick={() => setDisplayRankingWeightsModal(true)}>
              <Settings color={palette.chrome} />
            </SettingsIconContainer>

            {displayRankingWeightsModal && (
              <RankingWeightsModal
                rankingWeights={rankingWeights}
                onChangeRankingWeights={onChangeRankingWeights}
                onRequestClose={() => setDisplayRankingWeightsModal(false)}
              />
            )}
          </>
        )
      }}
    </Query>
  )
}
